import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-browser-blocker',
  templateUrl: './browser-blocker.component.html',
  styleUrls: ['./browser-blocker.component.scss'],
  imports: [MatIconModule],
})
export class BrowserBlockerComponent {}
